export default "__VITE_ASSET__1fabc601__"